export const MESSAGE_DIRECTION = Object.freeze({
  OUTGOING: 'outgoing',
  INCOMING: 'incoming',
})
